import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contrNo: null,
  spr: {
    sprCode: null,
    sprName: null,
    sprEnName: null,
  },
  proj: {
    projStatusCodeId: null,
    prioCodeId: null,
    // contrNo: null,
    name: null,
    color: null,
  },
};

export const contractSlice = createSlice({
  name: "contract",
  initialState,
  reducers: {
    updateAll: (state, action) => {
      return {
        ...state,
        contrNo: action.payload.contrNo,
        spr: {
          sprCode: action.payload.sprCode,
          sprName: action.payload.sprName,
          sprEnName: action.payload.sprEnName,
        },
        proj: {
          projStatusCodeId: action.payload.projStatusCodeId,
          prioCodeId: action.payload.prioCodeId,
          //   contrNo: action.payload.contrNo,
          name: action.payload.name,
          color: action.payload.color,
        },
      };
    },
    updateSprCode: (state, action) => {
      return {
        ...state,
        spr: {
          ...state.spr,
          sprCode: action.payload.sprCode,
        },
      };
    },
    updateSprName: (state, action) => {
      return {
        ...state,
        spr: {
          ...state.spr,
          sprName: action.payload.sprName,
        },
      };
    },
    updateSprEnName: (state, action) => {
      return {
        ...state,
        spr: {
          ...state.spr,
          sprEnName: action.payload.sprEnName,
        },
      };
    },
    updateProjStatusCodeId: (state, action) => {
      return {
        ...state,
        proj: {
          ...state.proj,
          projStatusCodeId: action.payload.projStatusCodeId,
        },
      };
    },
    updatePrioCodeId: (state, action) => {
      return {
        ...state,
        proj: {
          ...state.proj,
          prioCodeId: action.payload.prioCodeId,
        },
      };
    },
    updateContrNo: (state, action) => {
      return {
        ...state,
        contrNo: action.payload.contrNo,
        // proj: {
        //   ...state.proj,
        //   contrNo: action.payload.contrNo,
        // },
      };
    },
    updateName: (state, action) => {
      return {
        ...state,
        proj: {
          ...state.proj,
          name: action.payload.name,
        },
      };
    },
    updateColor: (state, action) => {
      return {
        ...state,
        proj: {
          ...state.proj,
          color: action.payload.color,
        },
      };
    },
  },
});

export const {
  updateAll,
  updateSprCode,
  updateSprName,
  updateSprEnName,
  updateProjStatusCodeId,
  updatePrioCodeId,
  updateContrNo,
  updateName,
  updateColor,
} = contractSlice.actions;

export default contractSlice.reducer;
